import CONSTANTS from "./constants";
import toastr from "toastr";
import "./../../node_modules/toastr/build/toastr.min.css";
toastr.options = {
	timeOut: 2500,
	showDuration: 1000,
	hideDuration: 1000,
	showEasing: `swing`,
	hideEasing: `linear`,
	showMethod: `fadeIn`,
	hideMethod: `fadeOut`
};

export function handle(result) {
	if (
		result.status === CONSTANTS.STATUS_CODE.OK ||
		result.status === CONSTANTS.STATUS_CODE.CREATED ||
		result.status === CONSTANTS.STATUS_CODE.ACCEPTED ||
		result.status === CONSTANTS.STATUS_CODE.NO_CONTENT
	) {
		toastr.success(result.message, result.title);
	} else {
		toastr.error(result.message, result.title);
	}
}
